import { useEffect } from 'react';

// Injects JSON-LD into <head> and removes it again on unmount, so a route
// change can never leave the previous page's structured data describing this
// one - the same failure mode the meta tags had.
//
// Each mount owns one <script> keyed by `id`; nulls in `data` are dropped, so a
// page can pass a graph that is only partly available while data loads.
export default function JsonLd({ id, data }) {
  const payload = (Array.isArray(data) ? data : [data]).filter(Boolean);
  // Serialised here so the effect re-runs on content change, not identity.
  // `<` is escaped because product and FAQ copy is user-entered: a literal
  // "</script>" in a description would otherwise break out of the tag for
  // anything reading the serialised DOM.
  const json = payload.length
    ? JSON.stringify(payload.length === 1 ? payload[0] : payload).replace(/</g, '\\u003c')
    : '';

  useEffect(() => {
    if (!json) return undefined;
    const selector = `script[type="application/ld+json"][data-jsonld="${id}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-jsonld', id);
      document.head.appendChild(el);
    }
    // textContent, never innerHTML: the payload carries product and FAQ copy
    // that must never be parsed as markup.
    el.textContent = json;
    return () => el.remove();
  }, [id, json]);

  return null;
}
